import React from 'react';

// Skeleton for metric cards
export const MetricCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-start justify-between mb-4">
      <div className="flex-1">
        <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
        <div className="h-8 bg-gray-300 rounded w-20"></div>
      </div>
      <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
    </div>
    <div className="flex items-center gap-2">
      <div className="h-3 bg-gray-200 rounded w-16"></div>
      <div className="h-3 bg-gray-200 rounded w-12"></div>
    </div>
  </div>
);

// Skeleton for chart panels
export const ChartPanelSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-48"></div>
      <div className="h-4 bg-gray-200 rounded w-24"></div>
    </div>
    <div className="space-y-3">
      <div className="h-48 bg-gray-100 rounded-lg"></div>
      <div className="flex justify-between">
        <div className="h-3 bg-gray-200 rounded w-16"></div>
        <div className="h-3 bg-gray-200 rounded w-16"></div>
        <div className="h-3 bg-gray-200 rounded w-16"></div>
        <div className="h-3 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  </div>
);

// Skeleton for system health monitor
export const SystemHealthSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-40 mb-6"></div>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {[1, 2, 3, 4]?.map((i) => (
        <div key={i} className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-6 bg-gray-300 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for alerts panel
export const AlertsPanelSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-32"></div>
      <div className="h-4 bg-gray-200 rounded w-20"></div>
    </div>
    <div className="space-y-4">
      {[1, 2, 3]?.map((i) => (
        <div key={i} className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="w-10 h-10 bg-gray-200 rounded-full flex-shrink-0"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for revenue metrics panel
export const RevenuePanelSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-6 bg-gray-300 rounded w-40 mb-6"></div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4]?.map((i) => (
        <div key={i} className="space-y-3">
          <div className="h-4 bg-gray-200 rounded w-24"></div>
          <div className="h-8 bg-gray-300 rounded w-28"></div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

// Skeleton for referral card
export const ReferralCardSkeleton = () => (
  <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-lg shadow-md p-6 border border-purple-100 animate-pulse">
    <div className="flex items-center gap-3 mb-4">
      <div className="w-10 h-10 bg-purple-200 rounded-lg"></div>
      <div className="h-6 bg-purple-300 rounded w-48"></div>
    </div>
    <div className="space-y-3">
      <div className="h-4 bg-purple-200 rounded w-32"></div>
      <div className="h-10 bg-white/50 rounded-lg"></div>
      <div className="flex gap-2">
        <div className="h-9 bg-purple-300 rounded flex-1"></div>
        <div className="h-9 bg-purple-200 rounded w-20"></div>
      </div>
    </div>
  </div>
);

// Skeleton for user management panel
export const UserManagementSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="flex items-center justify-between mb-6">
      <div className="h-6 bg-gray-300 rounded w-40"></div>
      <div className="h-9 bg-gray-200 rounded w-32"></div>
    </div>
    <div className="space-y-3">
      {[1, 2, 3, 4, 5]?.map((i) => (
        <div key={i} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div className="flex items-center gap-3 flex-1">
            <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
            <div className="space-y-2 flex-1">
              <div className="h-4 bg-gray-300 rounded w-32"></div>
              <div className="h-3 bg-gray-200 rounded w-48"></div>
            </div>
          </div>
          <div className="h-6 bg-gray-200 rounded w-16"></div>
        </div>
      ))}
    </div>
  </div>
);

export default {
  MetricCardSkeleton,
  ChartPanelSkeleton,
  SystemHealthSkeleton,
  AlertsPanelSkeleton,
  RevenuePanelSkeleton,
  ReferralCardSkeleton,
  UserManagementSkeleton
};